<template>
    <div class="base-button">
        <img class="base-button__icon" :src="this.src">
    </div>
</template>

<script>
    export default {
        name: "BaseButton",
        props: {
            src: String,
        }
    }
</script>

<style scoped>
    .base-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
        user-select: none;
    }
    .base-button:hover {
        background-color: rgba(51,51,51,0.08);
    }
    .base-button__icon {
        width: 24px;
        height: 24px;
    }
</style>
